<template>
    <b-card class="mb-5">
        <b-row>
            <b-col md="6">
                <h3>{{$route.name}}</h3>
                <b-breadcrumb>
                    <b-breadcrumb-item><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item>
                    <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
                </b-breadcrumb>
            </b-col>
            <b-col md="6 mt-3 float-right">
                <b-button variant="primary" class="mb-2 float-right btn-custom" @click="showModal('Add')"><font-awesome-icon icon="plus"/></b-button>
            </b-col>
        </b-row>
        <div class="border-bottom mb-5"></div>
        <paginated-table ref="dataTable" :can-edit="false" :can-delete="true" :can-show="false" :can-approve="false" :can-edit-modal="true" v-on:editData="doEdit" :can-reject="false" :data-url="apiUrl" :data-key="dataKey" :data-columns="columns">
        </paginated-table>
        <b-modal ref="my-modal" centered hide-footer :title="type + ' Photo Category'">
            <form v-on:submit.prevent="doSubmit">
                <label>Name *</label>
                <b-form-input :required="true" for-input="name" type="text" name="name" id="name" label="Name" placeholder="Enter name" v-validate="modelValidations.name" :error="errors.first('name')" v-model="model.name" data-vv-as="name"/><br>
                <label>Min. Photo Required *</label>
                <b-form-input :required="true" for-input="minPhotosRequired" type="number" name="minPhotosRequired" id="minPhotosRequired" label="Min. Photo Required" placeholder="Enter min photo required" v-validate="modelValidations.minPhotosRequired" :error="errors.first('minPhotosRequired')" v-model="model.minPhotosRequired" data-vv-as="min photo required"/><br>
                <div class="form-group" v-bind:class="{ 'has-error': errors.first('dob') }">
                    <label>Photo Category Condition *</label>
                    <b-form-group>
                        <b-form-radio-group
                            id="radio-group-1"
                            v-model="model.isRequired"
                            :options="options"
                            name="radio-option"
                            v-validate="modelValidations.isRequired"
                            data-vv-as="photo category condition">
                        </b-form-radio-group>
                    </b-form-group>
                    <slot name="infoBlock"></slot>
                    <slot name="helpBlock">
                        <div class="text-danger invalid-feedback" style="display: block;" v-if="errors.first('isRequired')">
                        {{ errors.first('isRequired') }}
                        </div>
                    </slot>
                </div>
                <label>Photo *</label>
                <div class="expander">
                    <b-form-file :required="true" label="Photo" for-input="photoinputGroupFile" :error="errors.first('photo')">
                        <div class="input-group">
                            <div class="custom-file">
                                <b-form-input type="file" class="custom-file-input" @change="onFileSelectedPhoto" ref="photo" id="photoinputGroupFile" accept="image/*" name="photo" v-validate="modelValidations.photo" :error="errors.first('photo')" data-vv-as="photo 3"/>
                                <label class="custom-file-label" for="photoinputGroupFile">{{model.photo !== null ? model.photo.name : 'Choose file'}}</label>
                            </div>
                            <div v-if="model.photo !== null" class="input-group-append">
                                <span class="input-group-text bg-danger text-white pointer" title="Clear Image" @click="clearImagePhoto"><font-awesome-icon icon="times"/></span>
                            </div>
                        </div>
                    </b-form-file>
                </div><br>
                <label>Order *</label>
                <b-form-input :required="true" for-input="order" type="number" name="order" id="order" label="Order" placeholder="Enter order" v-validate="modelValidations.order" :error="errors.first('order')" v-model="model.order" data-vv-as="order"/><br>
                <b-button variant="primary" class="btn-back float-right" type="submit"><font-awesome-icon icon="save"></font-awesome-icon> {{this.model.uuid !== null ? 'Update' : 'Submit'}} </b-button>
                <b-button variant="secondary" class="float-left mr-3" @click="hideModal"><font-awesome-icon icon="times-circle"></font-awesome-icon> Cancel</b-button>
            </form>
        </b-modal>
    </b-card>
</template>
<script>
    import PaginatedTable from '@/components/PaginatedTable'
    export default {
        name: 'vehicle-photo-category',
        components: {
            PaginatedTable
        },
        data () {
            return {
                dataKey: 'vehiclePhotoCategory',
                apiUrl: window.AppConfig.apiUrl + 'vehicle-photo-category',
                type: null,
                columns: [
                    {
                        key: 'name',
                        sortable: true
                    }, {
                        key: 'minPhotosRequired',
                        label: 'Min. Photos',
                        sortable: true
                    }, {
                        key: 'isRequired',
                        sortable: true
                    }, {
                        key: 'order',
                        sortable: true
                    }, {
                        key: 'photo',
                        sortable: true
                    }, {
                        key: 'createdAt',
                        sortable: true
                    }, {
                        key: 'actions',
                        label: '',
                        sortable: false
                    }
                ],
                options: [
                    { text: 'Optional', value: 0 },
                    { text: 'Required', value: 1 }
                ],
                model: {
                    uuid: null,
                    name: null,
                    minPhotosRequired: null,
                    isRequired: null,
                    order: null,
                    photo: null
                },
                modelValidations: {
                    name: {
                        required: true
                    },
                    minPhotosRequired: {
                        required: true
                    },
                    isRequired: {
                        required: true
                    },
                    order: {
                        required: true
                    }
                },
            }
        },
        methods: {
            doEdit (row) {
                this.type = row.type
                this.setData(row)
                this.$refs['my-modal'].show()
            },
            setData (row) {
                this.model.uuid = row.uuid
                this.model.name = row.name
                this.model.minPhotosRequired = row.minPhotosRequired
                this.model.isRequired = row.isRequired === true ? 1 : 0
                this.model.order = row.order
            },
            resetData () {
                this.model.uuid = null
                this.model.name = null
                this.model.minPhotosRequired = null
                this.model.isRequired = null
                this.model.order = null
                this.$validator.reset()
            },
            doSubmit () {
                this.$validator.validateAll().then(res => {
                    if (res) {
                            this.isLoading = true
                            let formData = new FormData()
                            formData.append('name', this.model.name)
                            formData.append('minPhotosRequired', this.model.minPhotosRequired)
                            formData.append('isRequired', this.model.isRequired)
                            formData.append('order', this.model.order)
                            if (this.model.photo !== null) {
                            formData.append('photo', this.model.photo, this.model.photo.name)
                        }
                        if (this.model.uuid !== null) {
                            let model = {}
                            Object.keys(this.model).forEach(element => {
                                if (element !== 'uuid') {
                                    model[element] = this.model[element]
                                }
                        })
                            this.$http.patch(this.apiUrl + '/' + this.model.uuid, formData).then(response => {
                                this.isLoading = false
                                this.$store.dispatch('notification/success', 'Photo Category successfully updated.')
                                this.$refs.dataTable.getDataTable()
                                this.resetData()
                                this.hideModal()
                            }).catch(error => {
                                this.isLoading = false
                                this.$store.dispatch('notification/error', error)
                            })
                        } else {
                            this.$http.post(this.apiUrl, formData).then(response => {
                                this.isLoading = false
                                this.$store.dispatch('notification/success', 'Photo Category successfully added.')
                                this.hideModal()
                                this.resetData()
                                this.$refs.dataTable.getDataTable()
                            }).catch(error => {
                                this.isLoading = false
                                this.$store.dispatch('notification/error', error)
                            })
                        }
                    }
                })
            },
            showModal(type) {
                this.model.name = null
                this.model.minPhotosRequired = null
                this.model.isRequired = null
                this.model.photo = null
                this.model.order = null
                this.model.uuid = null
                this.$validator.reset();
                this.type = type
                this.$refs['my-modal'].show()
            },
            hideModal () {
                this.resetData()
                this.$refs['my-modal'].hide()
            },
            onFileSelectedPhoto (event) {
                this.model.photo = event.target.files[0]
            },
            clearImagePhoto () {
                this.$refs.photo.value = ''
                this.model.photo = null
            }
        }
    }
</script>